import React from 'react';
import cx from 'classnames';
import styles from './CapabilityOverviewCharts.module.scss';

function formatPercent(score) {
  return typeof score === 'number' && Number.isFinite(score)
    ? `${Math.round(score * 100)}%`
    : 'No data';
}

export default function CapabilityOverviewBarTooltip({
  TooltipInPortal,
  tooltipOpen,
  tooltipData,
  tooltipLeft,
  tooltipTop,
  paletteIndex = 2,
}) {
  if (!tooltipOpen || !tooltipData) {
    return null;
  }

  return (
    <TooltipInPortal top={tooltipTop} left={tooltipLeft}>
      <div className={styles['tooltip']}>
        {(tooltipData.capabilitySetName ||
          tooltipData.ancestorPath.length > 0) && (
          <div className={styles['tooltip-path-list']}>
            {[...tooltipData.ancestorPath].reverse().map((name, index) => (
              <div
                className={styles['tooltip-path-list-item']}
                key={`${name}-${index}`}
              >
                <div className={styles['tooltip-path-list-item-name']}>
                  {name}
                </div>
                <div className={styles['tooltip-path-list-item-chevron']}>
                  &gt;
                </div>
              </div>
            ))}
            {tooltipData.capabilitySetName && (
              <div className={styles['tooltip-path-list-item']}>
                <div className={styles['tooltip-path-list-item-name']}>
                  {tooltipData.capabilitySetName}
                </div>
                <div className={styles['tooltip-path-list-item-chevron']}>
                  &gt;
                </div>
              </div>
            )}
          </div>
        )}
        <div className={styles['tooltip-capability']}>
          {tooltipData.capabilityName}
        </div>
        {tooltipData.elementName && (
          <div
            className={cx(
              styles['tooltip-element'],
              `palette-chart-${paletteIndex}`
            )}
          >
            <span className="palette-text">{tooltipData.elementName}</span>
          </div>
        )}
        <div>
          <strong>Mean:</strong> {formatPercent(tooltipData.metrics?.score)}{' '}
          {tooltipData.metrics?.minScore != null &&
            tooltipData.metrics?.maxScore != null && (
              <span className="text-muted">
                ({formatPercent(tooltipData.metrics?.minScore)} -{' '}
                {formatPercent(tooltipData.metrics?.maxScore)})
              </span>
            )}
        </div>
      </div>
    </TooltipInPortal>
  );
}
